package theme

import androidx.compose.ui.graphics.Color

class ThemeColor {
    init {
        instance = this
    }

    companion object {
        private var instance: ThemeColor? = null
        fun shared(): ThemeColor {
            if (instance == null) {
                instance = ThemeColor()
            }
            return instance as ThemeColor
        }
    }

    var windowWidth = 0
    var windowHeight = 0
    fun applyCustomTheme() {
//        val colorScheme: ColorScheme = Json.decodeFromString(BusinessConstants().theme)
//        PrimaryColor = Color(colorScheme.primaryColor.toLong())
    }

    val Purple200: Color = Color(0xFFBB86FC)
    val Purple500: Color = Color(0xFF6200EE)
    val Purple700: Color = Color(0xFF3700B3)
    val Teal200: Color = Color(0xFF03DAC5)


    //custom color
    val Purple80: Color = Color(0xFFD0BCFF)

    //val PrimaryColor = Color(0xFFFCC300)//ritik
    var PrimaryColor: Color = Color(0xFF0631A4)//ankur

    val PrimaryLightColor: Color = Color(0xFF0631A4)
    val defaultBakground: Color = Color(0xFFCCD1D9)
    val cardBackground: Color = Color(0xFFFFFFFF)
    val SecondaryColor: Color = Color(0xFF979797)
    val TertiaryColor: Color = Color(0xFF979797)
    val TextColor: Color = Color(0xFF757575)
    val placeholderColor: Color = Color(0xFF434A54)
    val TitleColor: Color = Color(0xFF000000)

    val White: Color = Color(0xFFFFFFFF)
    val Black: Color = Color(0xFF000000)
    val lightGray: Color = Color(0xFF949494)

    val Background: Color = Color(0xFFFFFFFF)
    val InputFieldBorder: Color = Color(0xFFCBD5E1)
    val Green: Color = Color(0xFF228b22)//ankur
    val Red: Color = Color(0xFFFF0000)//ankur
    val semiTransparent = Color.Black.copy(alpha = 0.4f)
    val iconTint: Color = Color(0xFF0631A4)//ankur
}

fun String.toColorLong(): Long {
    if (this[0] == '#') { // Use a long to avoid rollovers on #ffXXXXXX
        var color = this.substring(1).toLong(16)
        if (this.length == 7) { // Set the alpha value
            color = color or -0x1000000
        } else require(this.length == 9) { "Unknown color" }
        return color
    }
    throw IllegalArgumentException("Unknown color")
}

fun String.color(): Color {
    return Color(this.toColorLong())
}